export const BACKGROUND_COLOR_KEY = 'backgroundColor'
